import { Megaphone, FlaskConical, HeartHandshake, RefreshCw } from "lucide-react";
import { VALUES } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

const ICONS = [Megaphone, FlaskConical, HeartHandshake, RefreshCw];

export default function Values() {
  return (
    <section
      id="values"
      data-testid="values-section"
      className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40"
    >
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow testid="values-eyebrow">{VALUES.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-7 font-display text-4xl font-light tracking-tight text-[#1c2b4a] md:text-5xl lg:text-6xl">
              {VALUES.heading}
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#5c6474]">
            Pillars of Impact — 04
          </span>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-px overflow-hidden rounded-sm border border-[var(--line)] bg-[var(--line)] sm:grid-cols-2">
        {VALUES.items.map((v, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={v.no} delay={i * 0.06}>
              <div
                data-testid={`value-${v.no}`}
                className="group relative h-full bg-white p-10 transition-colors duration-500 hover:bg-[#faf8f5] md:p-12"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-sm border border-[#9c7a33]/40 text-[#9c7a33] transition-colors duration-500 group-hover:bg-[#9c7a33] group-hover:text-white">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-mono text-xs text-[#9c7a33]">
                    PILLAR-{v.no}
                  </span>
                </div>
                <h3 className="mt-8 font-display text-2xl text-[#1c2b4a] md:text-3xl">
                  {v.title}
                </h3>
                <p className="mt-4 max-w-md text-base leading-relaxed text-[#5c6474]">
                  {v.body}
                </p>
                <span className="absolute inset-x-0 bottom-0 h-[2px] w-0 bg-[#9c7a33] transition-[width] duration-500 group-hover:w-full" />
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
